"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeopleSaga = void 0;

var inversify_1 = require("inversify");

var effects_1 = require("redux-saga/effects");

var social_core_1 = require("@xbox/social-core");

var PeopleActions_1 = require("../actions/PeopleActions");

var PeopleNormalizer_1 = require("../reducers/People/PeopleNormalizer");

var PeopleSaga =
/** @class */
function () {
  function PeopleSaga(peopleHubService, telemetryService) {
    this.peopleHubService = peopleHubService;
    this.telemetryService = telemetryService;
    this.sagas = [this.watchFetchPeople(), this.watchFetchPerson(), this.watchFetchFriends(), this.watchFetchPeopleByGamertag()];
  }

  PeopleSaga.prototype._fetchPeople = function (action) {
    var result, people, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleInProgress(true))];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.peopleHubService.getPeople(action.payload)];

        case 2:
          result = _a.sent();
          people = PeopleNormalizer_1.peopleNormalizer(result);
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleInProgress(false))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleCompleted(people))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          err_1 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleInProgress(false))];

        case 6:
          _a.sent();

          this.telemetryService.trackException(err_1, "FetchPeople");
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga.prototype._fetchPerson = function (action) {
    var result, err_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPersonInProgress(true))];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.peopleHubService.getPerson(action.payload)];

        case 2:
          result = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPersonInProgress(false))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPersonCompleted(result))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          err_2 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleInProgress(false))];

        case 6:
          _a.sent();

          this.telemetryService.trackException(err_2, "FetchPeople");
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga.prototype._fetchPeopleByGamertag = function (action) {
    var xuid, person, err_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 6,, 8]);

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleByGamertagInProgress(true))];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.peopleHubService.getXuidFromGamertag(action.payload)];

        case 2:
          xuid = _a.sent();
          return [4
          /*yield*/
          , this.peopleHubService.getPerson(xuid[0].id)];

        case 3:
          person = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleByGamertagInProgress(false))];

        case 4:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleByGamertagCompleted(person))];

        case 5:
          _a.sent();

          return [3
          /*break*/
          , 8];

        case 6:
          err_3 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchPeopleByGamertagInProgress(false))];

        case 7:
          _a.sent();

          this.telemetryService.trackException(err_3, "FetchPeopleByGamertag");
          return [3
          /*break*/
          , 8];

        case 8:
          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga.prototype._fetchFriends = function () {
    var result, friends, err_4;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchFriendsInProgress(true))];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.peopleHubService.getFriends()];

        case 2:
          result = _a.sent();
          friends = PeopleNormalizer_1.peopleNormalizer(result);
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchFriendsInProgress(false))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchFriendsCompleted(friends))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          err_4 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(PeopleActions_1.PeopleActions.fetchFriendsInProgress(false))];

        case 6:
          _a.sent();

          this.telemetryService.trackException(err_4, "FetchFriends");
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga.prototype.watchFetchFriends = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(PeopleActions_1.PeopleActions.fetchFriends.type, this._fetchFriends.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga.prototype.watchFetchPeople = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(PeopleActions_1.PeopleActions.fetchPeople.type, this._fetchPeople.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga.prototype.watchFetchPerson = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(PeopleActions_1.PeopleActions.fetchPerson.type, this._fetchPerson.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga.prototype.watchFetchPeopleByGamertag = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(PeopleActions_1.PeopleActions.fetchPeopleByGamertag.type, this._fetchPeopleByGamertag.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  PeopleSaga = __decorate([inversify_1.injectable(), __param(0, inversify_1.inject(social_core_1.XSocialSymbols.IPeopleHubService)), __param(1, inversify_1.inject(social_core_1.XSocialSymbols.ITelemetryService)), __metadata("design:paramtypes", [Object, Object])], PeopleSaga);
  return PeopleSaga;
}();

exports.PeopleSaga = PeopleSaga;